"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_query_1 = require("@tanstack/react-query");
const components_1 = require("@/common/components");
const _1 = require(".");
const queryClient = new react_query_1.QueryClient();
function default_1() {
    const leader = (0, react_redux_1.useSelector)((state) => state.roomData.leader);
    const reviewCount = (0, react_redux_1.useSelector)((state) => state.roomData.review_count);
    const dispatch = (0, react_redux_1.useDispatch)();
    const updateLeaderReviewCount = (review_count) => {
        dispatch((0, roomViewStore_1.setLeaderReviewCount)(review_count));
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-table-row", css: { display: 'flex', flexDirection: 'column', rowGap: '10px', paddingBottom: '200px' } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "surface-white", css: { padding: '20px 16px' } }, { children: (0, jsx_runtime_1.jsx)(components_1.RecommendGraph, { channelId: leader, updateLeaderReviewCount: updateLeaderReviewCount }) })), !!reviewCount && ((0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, Object.assign({ client: queryClient }, { children: (0, jsx_runtime_1.jsx)(_1.ReviewContents, { leaderChannelId: leader }) })))] })));
}
exports.default = default_1;
